export default {
  noLikesFound: 'No se encontraron gustos',
  noMusicalGenresFound: 'No hay géneros musicales por el momento',
  noArtistsFound: 'No hay artistas por el momento',
  noSongsFound: 'No hay canciones por el momento',
  extraData: 'Datos adicionales',
  noExtraDataFound: 'No se encontró información adicional',
  typeOfRegister: 'Tipo de registro',
  createList: 'Crear lista',
  import: 'Importar',
  invitations: 'Invitaciones',
  invite: 'Invitar',
  seeGuests: 'Ver invitados',
  addNew: 'Agregar nuevo',
  mustChargeBeforeCreatePeople: 'Debes recargar dinero antes de crear personas',
  invited: 'Invitado',
  verified: 'Verificado',
  notVerified: 'Sin verificar',
  imported: 'Importado',
  notImported: 'No importado',
  oneTimePassword: 'Contraseña de un solo uso',
  changePassword: 'Cambiar contraseña',
  deletePerson: 'Borrar persona',
  loading: 'Cargando',
  noPeopleRegistered: 'No hay personas registradas',
  emailOrPhone: 'Email o teléfono',
  method: 'Método',
  creationDate: 'Fecha de creación',
  actions: 'Acciones',
  customizedSearch: 'Búsqueda personalizada',
  state: 'Estado',
  createPerson: 'Crear persona',
  perPage: 'por página',
  loadFile: 'Cargar archivo',
  organizeData: 'Organizar datos',
  verify: 'Verificar',
  pickToImportBusinessesOrPeopleToNewList: 'Selecciona si quieres importar negocios o personas a una lista existente',
  pickToSavePeopleToList: 'Selecciona si quieres guardar las personas que estás importando en una lista',
  business: 'Negocio',
  existentList: 'Lista Existente',
  newList: 'Nueva lista',
  noList: 'Sin lista',
  listsNotCreated: 'No se ha creado ninguna lista',
  pickAList: 'Selecciona una lista',
  typeNameOfTheList: 'Escribe el nombre de la lista',
  uploadFileTypeInfo: 'Sube el archivo en formato Excel o CSV donde tengas guardados tus contactos',
  pickFile: 'Seleccionar archivo',
  identifyImportedFields: 'Identifica cada campo de acuerdo a la información que van a contener',
  newColumnName: 'Nuevo nombre de columna',
  verifyInfoBeforeListCreation: 'Verifica que la información esté correcta antes de continuar con la creación de la lista',
  cancel: 'Cancelar',
  goBack: 'Volver',
  continue: 'Continuar',
  message: 'Mensaje',
  other: 'Otro',
  contact: 'Contacto',
  company: 'Compañia',
  address: 'Dirección',
  document: 'Documento',
  image: 'Imagen',
  location: 'Localización',
  observation: 'Observación',
  position: 'Posición',
  phone: 'Teléfono',
  phonePaste: 'Pegar número de teléfono',
  phoneWrite: 'Escribir número de teléfono',
  validPhone: 'Teléfono válido',
  invalidPhone: 'Teléfono inválido',
  switchPasteModePhone: 'Cambiar a modo de pegado de télefono',
  switchWriteModePhone: 'Cambiar a modo de escritura de télefono',
  pickWhereToSavePeopleToImport: 'Seleccione dónde desea guardar las personas a importar',
  pleaseAddAValidFile: 'Selecciona un achivo válido',
  errorReadingTheFile: 'Ocurrió un error leyendo el archivo',
  newPerson: 'Nueva persona',
  password: 'Contraseña',
  addNewPerson: 'Agregar nueva persona',
  personSuccessfullyAdded: 'Persona agregada correctamente',
  sendEmailTo: 'Enviar email a',
  sendSMSTo: 'Enviar SMS a',
  call: 'Llamar',
  downloadContact: 'Descargar contacto',
  editUser: 'Editar usuario',
  know: 'Conoce',
  connect: 'Conecta',
  emailVerify: 'Verificar Email',
  talk: 'Inbox',
  tasks: 'Tareas',
  record: 'Historial',
  addPersonEmailOrPhoneToNotifyAboutTaskStatus: 'Añadir un correo y/o teléfono para notificar a otra persona sobre los cambios de esta tarea',
  observations: 'Observaciones',
  editTask: 'Editar tarea',
  youMustAddTheNameOfTheTask: 'Debes agregar el nombre de la tarea',
  sameNameTask: 'Ya existe una tarea con este nombre',
  taskSuccessfullyDeleted: 'Tarea elminada exitosamente',
  noPersonNotes: 'Este usuario no tiene notas guardadas',
  insertNewNote: 'Inserta una nueva nota',
  currentNotes: 'Notas guardadas',
  editNote: 'Editar esta nota',
  deleteNote: 'Eliminar esta nota',
  errorUpdatingNotes: 'No se han podido actualizar las notas',
  clickPendingTasks: 'Click para ver detalles de las tareas',
  tasksList: 'Lista de tareas',
  tasksDueToday: 'Para hoy',
  tasksDueAfter: 'Para después',
  tasksDueBefore: 'Vencidas',
  daysRemaining: 'Dias hábiles',
  extraManagementAddNewField: 'Agregar nuevo campo de información',
  extraManagementAditionalInfo: 'Información adicional de las personas de tu marca',
  extraManagementItemAccessApplication: 'Solo puede ser visto por el administrador de la aplicación',
  extraManagementItemAccessPerson: 'Puede ser visto por las personas',
  extraCreatorShortText: 'Campo de texto breve',
  extraCreatorLongText: 'Campo de texto largo',
  extraCreatorList: 'Lista desplegable',
  extraCreatorRadioList: 'Lista de botones radiales',
  extraCreatorCheckList: 'Lista de recuadros marcados',
  extraCreatorEmail: 'Correo electrónico',
  extraCreatorCreateField: 'Crea un campo de información adicional',
  extraCreatorEditField: 'Edita un campo de información adicional',
  extraCreatorFieldName: 'Nombre del campo',
  extraCreatorFieldType: 'Tipo del campo',
  extraCreatorFieldAccess: 'Acceso del campo',
  extraCreatorAddOptions: 'Agrega las opciones',
  extraCreatorOption: 'Opción',
  extraCreatorApplication: 'Aplicación',
  extraCreatorApplicationInfo: 'Permite solo a la aplicación visualizar y modificar este campo desde el administrador',
  extraCreatorPersonInfo: 'Permite a los usuarios visualizar y modificar este campo desde su perfil',
  extraCreatorAddTags: 'Agrega algunas etiquetas',
  extraCreatorMessageEnterTag1: 'No hay resultados que coincidan',
  extraCreatorMessageEnterTag2: 'Presiona',
  extraCreatorMessageEnterTag3: 'para crear uno nuevo',
  setResponsible: 'Asigna un responsable',
  assign: 'Asignar',
  selectResponsible: 'Seleccione un responsable para esta lista de nuevos usuarios',
  pickAResponsible: 'Escoge un responsable',
  selectResponsibleSolo: 'Seleccione un responsable para ese usuario',
  seeLess: 'Ver menos',
  favoriteSongs: 'Canciones favoritas',
  favoriteMusicalGenres: 'Géneros musicales favoritos',
  favoriteArtists: 'Artistas favoritos',
  noInstagramSpotifyTags: 'Aún no se tienen gustos de instagram ni preferencias musicales',
  addToList: 'Agregar a la lista',
  noPersonRecords: 'Este usuario no tiene hisotrial de acciones',
  personAddedToList: 'Persona agregada a la lista',
  messageSuccessfullySent: 'Mensaje enviado correctamente',
  loadCsv: 'Cargar CSV',
  insertInvitedPeopleEmailPhone: 'Inserta los correos o teléfonos separados por comas de las personas que deseas invitar',
  noEmail: 'Sin email',
  noPhone: 'Sin teléfono',
  noLoadedInvitations: 'No hay invitaciones cargadas',
  downloadCsv: 'Descargar CSV',
  invitePerson: 'Invitar persona',
  inviteAdministrator: 'Invitar usuario',
  invitedPeople: 'Personas invitadas',
  sendSms: 'Enviar SMS',
  resendInvitations: 'Reenviar invitaciones',
  noInvitationsSent: 'No hay invitaciones enviadas',
  noAssistantSelected: 'No has seleccionado ningún asistente',
  thisEmailIsGoingToBeSentTo: 'Este email se va enviar a',
  assistants: 'Asistentes',
  noPersonSelected: 'No has seleccionado ningúna persona',
  allTheEventAssistants: 'todos los asistentes de {event}',
  close: 'Cerrar',
  send: 'Enviar',
  accept: 'Aceptar',
  actualPassword: 'Contraseña actual',
  change: 'Cambiar',
  youAreAboutToChangeUserPassword: 'Estás a punto de cambiar la contraseña de {user}, recuerda informarle a la persona la nueva contraseña',
  saveChanges: 'Guardar cambios',
  onetimePasswordUse: 'La contraseña que se genera puede ser utilizada una sola vez',
  sendToPersonEmail: 'Enviar al correo de la persona',
  sendToPersonPhone: 'Enviar al teléfono de la persona',
  generatePassword: 'Generar contraseña',
  passwordCopiedToClipboard: 'La contraseña ha sido copiada al portapapeles',
  errorCopyingThePassword: 'Error al copiar la contraseña',
  doYouWantToDeleteThisPerson: '¿Deseas eliminar esta persona?',
  personSuccessfullyDeleted: 'Persona borrada exitosamente',
  selectFinishingDate: 'Selecciona la fecha de entrega',
  pick: 'Seleccionar',
  selectFinishingHour: 'Seleccionar la hora de finalización',
  createTask: 'Crear tarea',
  currentTasks: 'Tareas en curso',
  noTasksToDo: 'No hay tareas por hacer',
  hour: 'Hora',
  date: 'Fecha',
  moveToDoneTasks: 'Mover a tareas realizadas',
  deleteTask: 'Eliminar tarea',
  completedTasks: 'Tareas completadas',
  noCompletedTasks: 'No hay tareas completadas',
  moveToUndoneTasks: 'Mover a tareas sin realizar',
  errorUpdatingTasks: 'No se han podido actualizar las tareas',
  enterTheNameAndDescriptionOfTheTask: 'Ingresa el nombre y observaciones de la tarea',
  insertANewTask: 'Inserta una nueva tarea',
  editProfile: 'Editar perfil',
  insertFullName: 'Ingresa tu nombre completo',
  insertYourEmail: 'Ingresa tu email',
  addRoles: 'Agregar tags',
  description: 'Descripción',
  userDescription: 'Descripción del usuario',
  notes: 'Notas',
  addCommentsAboutThisPerson: 'Agrega comentarios sobre esta persona',
  noInformation: 'Sin información',
  updatedCorrectly: 'Actualizado correctamente',
  searchCountry: 'Buscar país',
  countryNotFound: 'No se encontró ningún país',
  uploadDocument: 'Subir documento',
  downloadDocument: 'Descargar documento',
  editDocument: 'Editar documento',
  deleteDocument: 'Borrar documento',
  documents: 'Documentos',
  deleteDocumentConfirmation: '¿Estás seguro de querer eliminar este documento?',
  insertDocumentDescription: 'Ingresa la descripción del documento',
  editDescription: 'Editar descripción',
  documentSuccessfullyDeleted: 'El documento se ha eliminado correctamente',
  youMustPickADocumentToEdit: 'Debes seleccionar un documento a editar',
  fileSizeMustBeUnderXSize: 'El archivo adjunto debe pesar menos de {size}',
  documentSuccessfullyEdited: 'Documento editado correctamente',
  documentSuccessfullyUploaded: 'El documento se ha subido correctamente',
  editList: 'Editar lista',
  listCorrectlyUpdated: 'Lista actualizada correctamente',
  personDeletedFromList: 'Persona borrada de la lista',
  doYouWantToDeleteThisList: '¿Desea borrar esta lista?',
  deleteList: 'Borrar lista',
  listDeleted: 'Lista borrada',
  lists: 'Listas',
  create: 'Crear',
  campaign: 'Campaña',
  peopleLists: 'Personas en la lista',
  peopleListsNotCreated: 'Aún no has creado ninguna lista de personas',
  peopleInTheList: 'Personas en la lista',
  listName: 'Nombre de la lista',
  waitUntilTheListGetsCreated: 'Espere mientras se crea la lista',
  loadingPeopleFromTheList: 'Cargando las personas de la lista',
  noPeopleInThisList: 'No hay personas en esta lista',
  rolesNotCreated: 'Aún no hay tags creados',
  code: 'Código',
  nameOfTheRol: 'Nombre del tag',
  newRol: 'Nuevo tag',
  addNewRol: 'Agregar nuevo tag',
  rolSuccessfullyCreated: 'Tag creado correctamente',
  editRol: 'Editar tag',
  rolSuccessfullyEdited: 'Tag editado correctamente',
  columnsTable: 'Columnas',
  edit: 'Editar',
  loadingPerson: 'Cargando persona',
  weCouldNotFindThisPerson: 'No pudimos encontrar esta persona',
  youMustAddKeyToUpdateUser: 'Debes añadir una clave para actualizar la persona',
  noDocumentsWereFoundForThisPerson: 'No se han subido documentos asociados a esta persona',
  email: 'Email',
  verifyEmail: 'Validar Email',
  roles: 'Tags',
  updateAppPublicKey: 'Actualice key de la aplicación',
  emailSuccessfullyVerified: 'Email verificado con éxito',
  closeProfile: 'Cerrar perfil',
  journey: 'Journey',
  noJourneyForCurrentApp: 'Tu aplicación aún no cuenta con un Journey, crea un journey para agregar o cambiar un estado particular a esta persona',
  changeJourneyCurrentStatus: 'Cambia el estado del journey actual de esta persona',
  dependsOn: 'Depende de',
  journeyId: 'Journey ID',
  isDependencyOf: 'Es dependencia de',
  changeJourneyCurrentStatusWarning: '¿Estás seguro de querer cambiar el journey actual del usuario?',
  changeJourneyStatus: 'Cambiar el estado del Journey',
  customFields: 'Campos Personalizados',
  seeFilters: 'Ver filtros',
  hideFilters: 'Esconder filtros',
  peopleFilters: 'Filtros de personas',
  clearFields: 'Limpiar campos',
  startEditingMode: 'Cambiar a modo edición',
  stopEditingMode: 'Parar modo edición',
  createNewTaskToAssignInBlock: 'Crea la nueva tarea a asignar en bloque',
  taskCreatedSuccessfully: 'Tarea creada exitosamente',
  chooseTheTypeOfBlockEdition: 'Comienza por seleccionar el tipo de edición en bloque que deseas hacer para continuar con el proceso.',
  modifyTheAdditionalDataThatYouWant: 'Modifica los datos adicionales que desees',
  justTheFilledExtraDataAreGoingToBeChanged: 'Solo serán cambiados los datos adicionales a los cuales les ingreses una información, los demás campos serán ignorados.',
  pickTheJourneyStatusToAssignInBlock: 'Selecciona el estado del Journey a asignar',
  editInBlock: 'Editar en bloque',
  enterInformation: 'Ingresar información',
  modifyAtLeastOneExtraDataToEditInBlock: 'Debes modificar por lo menos un dato adicional para poder editar en bloque',
  addAJourneyStatusToEditInBlock: 'Debes seleccionar un estado del Journey para poder editarlo en bloque',
  createAValidTaskToAddInBlock: 'Debes crear una tarea valida para poder agregarla en bloque',
  editPeopleInBlock: 'Editar personas en bloque',
  aListWithThisNameAlreadyExists: 'Ya existe una lista con el mismo nombre',
  addTheNameOfTheListToBeCreated: 'Añade el nombre de la lista a crear',
  changeExtraData: 'Cambiar información adicional',
  pickAtLeastOneTypeOfEditingToEditInBlock: 'Debes selecionar por lo menos un tipo de edición para poder editar en bloque',
  editInBlockFinishedSuccessfully: 'Edición en bloque terminada exitosamente',
  youMustAddTagsInOrderToFilterExtraData: 'Debes añadirle etiquetas a los datos adicionales para poder filtrarlos por etiquetas',
  menu: 'Menu',
  of: 'de',
  responsible: 'Responsable',
  sendEmail: 'Enviar email',
  editResponsible: 'Editar Responsable',
  permissionsFor: 'Permisos para',
  // Importing people info
  numberOfRows: 'Número de filas',
  totalPeople: 'Personas totales',
  uniquePeople: 'Personas únicas',
  savedPeople: 'Personas guardadas',
  updatedPeople: 'Personas actualizadas',
  insertedPeople: 'Personas insertadas',
  duplicatedPeople: 'Personas duplicadas',
  importCompleted: 'Importación finalizada',
  importingBusinesses: 'Importando negocios',
  creatingList: 'Creando listas',
  firstName: 'Nombre',
  rol: 'Tag',
  businessInformationItems: 'Columnas con información de negocios',
  personalInformationItems: 'Columnas con información personal',
  extraDataItems: 'Columnas con información adicional',
  doYouWantToDeleteThisRol: 'Estás seguro de que quieres eliminar este rol?',
  rolSuccessfullyDeleted: 'Rol eliminado exitosamente',
  addSelectedUsersToList: 'Añadir usuarios seleccionados a una lista',
  usersSuccessfullyAddedToList: 'Usuarios añadidos exitosamente a la lista'
}
